import React from 'react'
import styles from './RepaymentTable.module.css'

const headers = ["Loan Amount", "$200", "$1,000", "$2,000", "$3,000", "$5,000"]
const rows = [
    ["Interest Rate (APR)", "15%", "13%", "11.5%", "10.5%", "10%"],
    ["Loan Term", "6 Months", "12 Months", "24 Months", "36 Months", "48 Months"],
    ["Prepayment Penalty", "NO", "NO", "NO", "NO", "NO"],
    ["Origination Fees", "NO", "NO", "NO", "NO", "NO"],
    ["Monthly Payments", "$34.71", "$89.32", "$93.68", "$97.51", "$126.81"],
    ["Total Payments", "$208.28", "$1,071.81", "$2,248.34", "$3,510.26", "$6,087.02"]
]

export const RepaymentTable = () => {
    return (
        <section className={styles.repaymentSection}>
            <div className={styles.headerBlock}>
                <p className={styles.subTitle}>Representative Example</p>
                <h2 className={styles.sectionTitle}>Repayment Plan For Various Loan Amounts and Terms</h2>
            </div>

            <div className={styles.tableContainer}>
                <table className={styles.repaymentTable}>
                    <thead>
                        <tr>
                            {headers.map((head, index) => (
                                <th key={index}>{head}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rIndex) => (
                            <tr key={rIndex} className={rIndex % 2 === 0 ? styles.rowEven : styles.rowOdd}>
                                {row.map((cell, cIndex) => (
                                    <td key={cIndex} className={cIndex === 0 ? styles.firstCol : ''}>
                                        {cell}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <p className={styles.disclaimer}>
                Each lender has their terms, fees, and policies. Loan details, such as fees, rates, APR, nonpayment rules, and renewal policy, vary by lender and state and are outlined in your agreement. On our part, we provide plenty of information that can help you better understand what a loan is, how it works, and how to use it wisely.
            </p>
        </section>
    )
}

export default RepaymentTable
